/**
 * The only module in the app that knows the dataLayer exists.
 *
 * IMPORTANT — why these are dataLayer.push({event}) and not gtag() calls:
 * the Google tag is loaded *through* GTM (public/index.html loads
 * GTM-WFNGCVFK, and the container holds a Google tag for G-D6XY6LGRCN).
 * On that setup `window.gtag` is never defined and gtag-style argument
 * pushes are ignored by GTM — they land in the array and are silently
 * dropped, with no console error and no network request. Verified against
 * production on 2026-09-01.
 *
 * So every event here must be a plain object with an `event` key, and each
 * one needs a matching Custom Event trigger + GA4 Event tag in GTM before
 * it reaches Analytics. See claude/analytics-refactor-plan.md.
 */

const push = (event, params = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};

/**
 * Enhanced conversions for Google Ads. Pushed as its own dataLayer entry
 * (no `event` key) so a GTM User-Provided Data variable can read it off
 * user_data.* when the conversion tag fires. Google hashes this in the
 * browser; raw values never leave the page.
 */
export const setUserData = ({ email, firstName, lastName }) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    user_data: {
      email_address: email,
      address: { first_name: firstName, last_name: lastName },
    },
  });
};

export const analytics = {
  ctaBookClick: (p) => push("cta_book_click", p),
  bookingFormStart: (p) => push("booking_form_start", p),
  bookingFormSubmit: (p) => push("booking_form_submit", p),
  bookingCompleted: (p) => push("booking_completed", p),
  bookingAbandoned: (p) => push("booking_abandoned", p),
  bookingError: (p) => push("booking_error", p),
  outboundProductClick: (p) => push("outbound_product_click", p),
  contactEmailClick: (p) => push("contact_email_click", p),
};

export default analytics;
